import * as React from 'react';
import MonacoEditor from 'react-monaco-editor';
import ResizeObserver from 'rc-resize-observer';
import { withRouter } from 'react-router-dom';
import { debounce } from 'vega';
import { SIDEPANE } from '../../constants';
import './config-editor.css';
class ConfigEditor extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleEditorChange = (spec) => {
            const newSpec = spec === '' ? '{}' : spec;
            this.props.setConfigEditorString(newSpec);
            this.props.setThemeName('custom');
            if (this.props.manualParse) {
                return;
            }
            this.props.setConfig(this.props.configEditorString);
        };
    }
    handleMergeConfig() {
        const confirmation = confirm('The spec will be formatted on merge.');
        if (!confirmation) {
            return;
        }
        if (this.props.history.location.pathname !== '/edited') {
            this.props.history.push('/edited');
        }
        this.props.mergeConfigSpec();
    }
    handleExtractConfig() {
        const confirmation = confirm('The spec and config will be formatted.');
        if (!confirmation) {
            return;
        }
        this.props.extractConfig();
    }
    handleEditorMount(editor) {
        editor.onDidFocusEditorText(() => {
            editor.deltaDecorations(this.props.decorations, []);
            this.props.setEditorReference(editor);
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 0,
            id: 'MERGE_CONFIG',
            label: 'Merge Config Into Spec',
            run: this.handleMergeConfig.bind(this),
        });
        editor.addAction({
            contextMenuGroupId: 'vega',
            contextMenuOrder: 1,
            id: 'EXTRACT_CONFIG',
            label: 'Extract Config From Spec',
            run: this.handleExtractConfig.bind(this),
        });
        this.editor = editor;
        if (this.props.sidePaneItem === SIDEPANE.Config) {
            this.editor.focus();
            this.editor.layout();
        }
    }
    componentDidMount() {
        if (this.props.sidePaneItem === SIDEPANE.Config) {
            this.props.setEditorReference(this.editor);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.sidePaneItem === SIDEPANE.Config) {
            this.editor.focus();
            this.editor.layout();
            this.props.setEditorReference(this.editor);
        }
    }
    render() {
        return (React.createElement(ResizeObserver, { onResize: ({ width, height }) => {
                this.editor.layout({ width, height: height });
            } },
            React.createElement(MonacoEditor, { language: "json", options: {
                    cursorBlinking: 'smooth',
                    folding: true,
                    lineNumbersMinChars: 4,
                    minimap: { enabled: false },
                    scrollBeyondLastLine: false,
                    wordWrap: 'on',
                    quickSuggestions: true,
                }, onChange: debounce(700, this.handleEditorChange), value: this.props.configEditorString, editorDidMount: (e) => this.handleEditorMount(e) })));
    }
}
export default withRouter(ConfigEditor);
